/**
 * ABWIN Scratch Popup — Storage
 * ---------------------------------------------------------------
 * All localStorage/sessionStorage access goes through here.
 */
(function (global) {
  "use strict";

  const cfg = global.ABWIN_POPUP_CONFIG;
  const NS = cfg.storageNamespace;

  const KEYS = {
    closedAt: `${NS}:closedAt`,
    claimedAt: `${NS}:claimedAt`,
    shownThisSession: `${NS}:shownThisSession`,
    lastCode: `${NS}:lastCode`,
    lastEmail: `${NS}:lastEmail`,
  };

  function safeGet(store, key) {
    try {
      return store.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(store, key, value) {
    try {
      store.setItem(key, value);
    } catch (e) {
      /* ignore */
    }
  }

  const AbwinStorage = {
    KEYS,

    hoursSince(timestamp) {
      return (Date.now() - Number(timestamp)) / (1000 * 60 * 60);
    },

    daysSince(timestamp) {
      return this.hoursSince(timestamp) / 24;
    },

    wasShownThisSession() {
      return safeGet(sessionStorage, KEYS.shownThisSession) === "1";
    },

    markShownThisSession() {
      safeSet(sessionStorage, KEYS.shownThisSession, "1");
    },

    markClosed() {
      safeSet(localStorage, KEYS.closedAt, String(Date.now()));
    },

    markClaimed(code, email) {
      safeSet(localStorage, KEYS.claimedAt, String(Date.now()));
      if (code) safeSet(localStorage, KEYS.lastCode, code);
      if (email) safeSet(localStorage, KEYS.lastEmail, email);
    },

    getLastCode() {
      return safeGet(localStorage, KEYS.lastCode);
    },

    isEligibleToShow() {
      const { frequency } = cfg;

      if (frequency.oncePerSession && this.wasShownThisSession()) {
        return { allowed: false, reason: "already_shown_this_session" };
      }

      const claimedAt = safeGet(localStorage, KEYS.claimedAt);
      if (claimedAt && this.daysSince(claimedAt) < frequency.claimedCooldownDays) {
        return { allowed: false, reason: "claimed_cooldown_active" };
      }

      const closedAt = safeGet(localStorage, KEYS.closedAt);
      if (closedAt && this.hoursSince(closedAt) < frequency.closedCooldownHours) {
        return { allowed: false, reason: "closed_cooldown_active" };
      }

      return { allowed: true, reason: null };
    },

    resetAll() {
      Object.values(KEYS).forEach((k) => {
        try {
          localStorage.removeItem(k);
          sessionStorage.removeItem(k);
        } catch (e) {
          /* ignore */
        }
      });
    },
  };

  global.AbwinStorage = AbwinStorage;
})(window);
